import "./projects.css";
import { arrayProjects } from "../../database";

const Projects = () => {
  return (
    <div className="containerProjects">
      <div className="containerParaCards">
        {arrayProjects.map((item, i) => {
          return (
            <div key={item.id} className="projectsCards">
              <h2>{item.name}</h2>
              <img src={item.image} alt="" />
              <p>{item.about}</p>
              <div className="cardButtons">
                <button>
                  <a
                    href={item.linkRepo}
                    target="_blank"
                    rel="nooperner noreferrer"
                  >
                    Repo
                  </a>
                </button>
                <button>
                  <a
                    href={item.linkDeploy}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Deploy
                  </a>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Projects;
